module.exports = __webpack_public_path__ + "assets/u57.bbe94bf4.svg";